import React from 'react';
import { connect } from 'react-redux';
import SecondaryNav from '../SecondaryNav/SecondaryNav';
import './subscription.scss';
import Summary from '../../common/Subscription/Summary';
import Button from '../../common/Button/Button';
import history from 'hb-redux-store/history';
import { getSummary } from 'hb-redux-store/feature/subscription/subscription.action';
import Loader from '../Skeletons/Loader/Loader';
import { getSubscriptionRoute } from './subscription.routes';
import { initializeMap } from 'hb-redux-store/util/locationService';

const SubscriptionSummary = props => {
  const { loading } = props;
  React.useEffect(() => {
    const { subscriptionId } = props.match.params;
    props.getSummary({ subscriptionNo: subscriptionId });
  }, []);
  let ctaText = 'Subscribe & Pay';
  let nextRoute = getSubscriptionRoute('payment');
  if (props.summary?.deliveryAddress?.newAddress) {
    const { latitude, longitude } = props.summary?.deliveryAddress;
    initializeMap({ coords: { latitude, longitude } });
    ctaText = 'Complete Your Address';
    nextRoute = getSubscriptionRoute('addAddress').replace(':addressId?', '');
  }

  return (
    <div className="subscription-summary">
      <SecondaryNav
        showSearch={false}
        showCart={false}
        capitalize
        title="Subscription Summary"
      />
      {!props.summary && <Loader />}
      {props.summary && <Summary summary={props.summary} />}
      <div className="bottom-sticky-cta">
        <Button
          type="submit"
          className="button button-secondary full-width large"
          onClick={() => history.push(nextRoute)}
          disabled={loading}
        >
          {ctaText}
        </Button>
      </div>
    </div>
  );
};

const mapStatetoProps = ({ subscriptionReducer }) => {
  return {
    loading: subscriptionReducer.loading,
    summary: subscriptionReducer.summary,
  };
};

const mapDispatchToProps = { getSummary };

export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(SubscriptionSummary);
